import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const Founder = () => (
    <section
        id="about"
        data-testid="founder-section"
        className="py-20 md:py-32 px-5 sm:px-8 lg:px-12 bg-[#141414]/60 rounded-[2.5rem] mx-3 md:mx-6 my-6 relative overflow-hidden"
    >
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -bottom-32 -right-24 w-[34rem] h-[34rem] rounded-full bg-[#CFCCC6]/30 blur-3xl"
        />
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center relative">
            <div className="lg:col-span-5">
                <Reveal>
                    <motion.div
                        whileHover={{ rotate: 0 }}
                        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                        className="relative rotate-[-2deg]"
                    >
                        <div className="rounded-[2rem] overflow-hidden border-4 border-[#F1F1EF] shadow-[0_35px_70px_-25px_rgba(140,138,134,0.4)]">
                            <img
                                src="/images/founder.jpg"
                                alt="Tabbie Shaw, founder of Savv Media"
                                data-testid="founder-photo"
                                loading="lazy"
                                className="w-full h-auto block"
                            />
                        </div>
                        <div className="absolute -bottom-5 left-6 bg-[#F1F1EF] rounded-2xl shadow-lg border border-[#262626] px-5 py-2.5 rotate-[2deg]">
                            <span className="font-hand text-2xl text-[#262626]">
                                Tabbie Shaw ♡
                            </span>
                        </div>
                    </motion.div>
                </Reveal>
            </div>

            <div className="lg:col-span-7">
                <Reveal>
                    <Eyebrow className="text-[#D3A0A7]">
                        Meet the Founder.
                    </Eyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-4 font-serif-ed text-4xl sm:text-5xl tracking-tight text-[#F1F1EF]">
                        Tabbie Shaw
                    </h2>
                </Reveal>
                <Reveal delay={0.18}>
                    <p
                        data-testid="founder-bio-1"
                        className="mt-6 text-base md:text-lg leading-relaxed text-[#A9A6A0]"
                    >
                        Behind Savv Media is Tabbie Shaw — a creative,
                        organized, and business-minded professional who believes
                        your brand should look as strong as the business behind
                        it.
                    </p>
                </Reveal>
                <Reveal delay={0.26}>
                    <p
                        data-testid="founder-bio-2"
                        className="mt-4 text-base md:text-lg leading-relaxed text-[#A9A6A0]"
                    >
                        With a background in marketing and promotions, client
                        communication, business operations, and digital
                        marketing, Tabbie brings both creativity and real-world
                        organization to every project. Savv Media was built to
                        help businesses turn their ideas into a polished,
                        recognizable presence that connects with the people they
                        want to reach.
                    </p>
                </Reveal>
                <Reveal delay={0.34}>
                    <p className="mt-6 font-hand text-2xl md:text-[1.7rem] text-[#D3A0A7]">
                        Founder. Marketing. Creativity. Your brand, made Savv.
                    </p>
                </Reveal>
                <Reveal delay={0.42}>
                    <a
                        href="#contact"
                        data-testid="founder-cta"
                        className="group mt-8 inline-flex items-center gap-2 bg-[#0C0C0C] text-[#F1F1EF] font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-[#D3A0A7] transition-colors duration-300"
                    >
                        Work with Savv
                        <ArrowRight
                            size={16}
                            className="transition-transform duration-300 group-hover:translate-x-1"
                        />
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
);
